import { z } from "zod";

export const UserAlertsDtoSchema = z.object({
  showPersonalizationsDialog: z.boolean().default(false),
  showPersonalizationMigrateBanner: z.boolean().default(false),
});

export type UserAlertsDto = z.infer<typeof UserAlertsDtoSchema>;

export const UserAlertsInitial: UserAlertsDto = {
  showPersonalizationMigrateBanner: false,
  showPersonalizationsDialog: false,
};
export const UserRolesList = ["intelligems", "admin", "member"] as const;
export type UserRoles = (typeof UserRolesList)[number];

export const UserOrganizationListDtoSchema = z.object({
  id: z.string().uuid(),
  name: z.string(),
  lastLoginTs: z.number().nullish(),
  shopId: z.string(),
  isInstalled: z.boolean(),
  createdAtTs: z.number().nullish(),
  roles: z.enum(UserRolesList).array(),
});

export type UserOrganizationListDto = z.infer<
  typeof UserOrganizationListDtoSchema
>;

export const UserDtoSchema = z.object({
  id: z.string().uuid(),
  firstName: z.string().nullish(),
  lastName: z.string().nullish(),
  email: z.string().email(),
  organizationId: z.string().uuid(),
  isBlocked: z.boolean(),
  showInfoPopup: z.boolean(),
  userAlerts: z.any().default({}),
  showWelcome: z.boolean().optional().default(true),
});

export type UserDto = z.infer<typeof UserDtoSchema>;

export const UserWithOrgListDtoSchema = UserDtoSchema.extend({
  organizations: UserOrganizationListDtoSchema.array(),
});

export type UserWithOrgListDto = z.infer<typeof UserWithOrgListDtoSchema>;

export const CreateUserDtoSchema = z.object({
  email: z.string(),
  firstName: z.string().optional(),
  lastName: z.string().optional(),
  password: z.string().optional(),
  showWelcome: z.boolean().optional().default(true),
  showInfoPopup: z.boolean().optional().default(true),
  userAlerts: z.any().default({}),
  organizationId: z.string().uuid(),
});
export type CreateUserDto = z.infer<typeof CreateUserDtoSchema>;

export const PatchUserDtoSchema = z.object({
  email: z.string().optional(),
  firstName: z.string().optional(),
  lastName: z.string().optional(),
  password: z.string().optional(),
  showWelcome: z.boolean().optional(),
  showInfoPopup: z.boolean().optional(),
  userAlerts: z.any().default({}),
  organizationId: z.string().uuid(),
  id: z.string().uuid(),
});

export type PatchUserDto = z.infer<typeof PatchUserDtoSchema>;
